module.exports = __webpack_public_path__ + "static/media/title-background.5f871e71.jpg";